// extracted by mini-css-extract-plugin
export var filterIncDec = "_d4-0";
export var leftBorder = "_d4-1";
export var rightBorder = "_d4-2";
export var stringInput = "_d4-3";